import { TextField, H4, Separator } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useQueryParams } from '@fs/zion-router'
import debounce from 'lodash.debounce'
import { useTimeTravel } from '../../providers'
import { getNowTimestamp, parseISOtoMs, parseMsToISO, roundTimestampDown } from '../helpers'
import { useOnce } from '../../hooks'

const DateTimeField = (props) => {
  return <TextField label="Enter Time:" type="datetime-local" placeholder="Unlock the Temporal Gateway" {...props} />
}

export default function TimeSelector({ paramKey, isOpen }) {
  const { query, setQuery, removeQuery } = useQueryParams()
  const { getNow, setNow } = useTimeTravel()
  const ISONow = parseMsToISO(roundTimestampDown({ time: getNow() }), true)
  const now = ISONow.replace('.000Z', '')
  const [value, setValue] = useState(now)

  // FIXME: onChange gets called twice when clearing the field; I think it has something to do with creating a new function each render, useTimeTravel is not very stable
  const onChange = debounce(
    (e) => {
      const newNow = e.target.value
      if (newNow) {
        setValue(newNow)
        setNow(parseISOtoMs(newNow))
        setQuery({ [paramKey]: newNow })
      } else {
        setValue(now)
        setNow(getNowTimestamp())
        removeQuery(paramKey)
      }
    },
    1000,
    { leading: true }
  )

  const onOnce = useOnce()
  useEffect(() => {
    if (isOpen) {
      onOnce(() => onChange({ target: { value: query[paramKey] } }))
    }
  }, [isOpen, onChange, onOnce, paramKey, query])

  return (
    <>
      <H4 size="H5">Time</H4>
      <Separator size="nano" />
      <DateTimeField value={value} onChange={onChange} />
    </>
  )
}
